import script from "./VirtualStation.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualStation.vue?vue&type=script&setup=true&lang=js"

import "./VirtualStation.vue?vue&type=style&index=0&id=a49a9b5e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a49a9b5e"]])

export default __exports__